export enum TipoProjetoEnum {
  LoteamentoAberto = 'Loteamento Aberto',
  CondominioIncorporacao = 'Condomínio Incorporação'
}
